import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { CategoriesService } from './api/categories.service';
import { ChildrenService } from './api/children.service';
import { ContractsService } from './api/contracts.service';
import { CurrentPapCategoriesService } from './api/currentPapCategories.service';
import { EduActivitiesService } from './api/eduActivities.service';
import { LastResultsService } from './api/lastResults.service';
import { MaterialsService } from './api/materials.service';
import { PapCategoriesService } from './api/papCategories.service';
import { RegistrationService } from './api/registration.service';
import { TeacherActivityService } from './api/teacherActivity.service';
import { TeacherActivityTargetLinkService } from './api/teacherActivityTargetLink.service';
import { TeacherAdditionalInfoService } from './api/teacherAdditionalInfo.service';
import { TeacherFilesService } from './api/teacherFiles.service';
import { TeacherResultsService } from './api/teacherResults.service';
import { TeacherTargetService } from './api/teacherTarget.service';
import { UsersService } from './api/users.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    CategoriesService,
    ChildrenService,
    ContractsService,
    CurrentPapCategoriesService,
    EduActivitiesService,
    LastResultsService,
    MaterialsService,
    PapCategoriesService,
    RegistrationService,
    TeacherActivityService,
    TeacherActivityTargetLinkService,
    TeacherAdditionalInfoService,
    TeacherFilesService,
    TeacherResultsService,
    TeacherTargetService,
    UsersService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
